var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.smartBets),function(smartBet,i){return _c('v-row',{key:i,attrs:{"justify":"center"}},[_c('image-card',{staticClass:"card-rounded mb-2",attrs:{"classes":"border--golden","width":"280","aspect-ratio":"1.4","src":smartBet.image,"lazy-src":smartBet.image,"alt":"cricket tutorials"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }